// Base expandida de sintomas/estados físicos — V1 (98 sintomas, 245 aliases, 212 relações).
// orgaoIds apontam para as fichas de órgão correspondentes citadas no guia.

export const SYMPTOMS = [
  {
    "id": "falta-de-ar",
    "sintoma": "Falta de ar",
    "aliases": [
      "respiração curta",
      "respiração fraca",
      "dificuldade para respirar",
      "cansaço ao respirar"
    ],
    "orgaoIds": [
      "pulmao",
      "coracao",
      "rins",
      "baco-pancreas",
      "pericardio"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo pulmao, coracao, rins, baco-pancreas, pericardio.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas.",
    "alerta": "Falta de ar importante, súbita ou em piora exige avaliação médica."
  },
  {
    "id": "tosse",
    "sintoma": "Tosse",
    "aliases": [
      "tossindo",
      "tosse fraca",
      "tosse sem força"
    ],
    "orgaoIds": [
      "pulmao"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo pulmao.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "suor-espontaneo",
    "sintoma": "Suor espontâneo",
    "aliases": [
      "suar sem esforço",
      "transpiração espontânea",
      "suor fácil ao esforço"
    ],
    "orgaoIds": [
      "pulmao",
      "coracao"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo pulmao, coracao.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "resfriados-frequentes",
    "sintoma": "Resfriados frequentes",
    "aliases": [
      "pega resfriado fácil",
      "resfria fácil"
    ],
    "orgaoIds": [
      "pulmao"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo pulmao.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "aversao-ao-vento",
    "sintoma": "Aversão ao vento",
    "aliases": [
      "sensível ao vento",
      "não gosta de vento"
    ],
    "orgaoIds": [
      "pulmao"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo pulmao.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "aversao-ao-frio",
    "sintoma": "Aversão ao frio",
    "aliases": [
      "sente muito frio",
      "intolerância ao frio"
    ],
    "orgaoIds": [
      "pulmao",
      "rins",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo pulmao, rins, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "aperto-no-peito",
    "sintoma": "Aperto ou pressão no peito",
    "aliases": [
      "peito apertado",
      "opressão no peito",
      "pressão torácica",
      "plenitude no peito",
      "peito cheio"
    ],
    "orgaoIds": [
      "pulmao",
      "coracao",
      "pericardio",
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo pulmao, coracao, pericardio, figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas.",
    "alerta": "Dor ou pressão torácica intensa, nova ou acompanhada de falta de ar exige avaliação urgente."
  },
  {
    "id": "palpitacao",
    "sintoma": "Palpitação",
    "aliases": [
      "palpitações",
      "coração acelerado",
      "coração batendo forte",
      "sentir o coração bater"
    ],
    "orgaoIds": [
      "coracao",
      "pericardio",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo coracao, pericardio, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "insonia",
    "sintoma": "Insônia",
    "aliases": [
      "dificuldade para dormir",
      "não consigo dormir",
      "sono ruim",
      "sono agitado",
      "sono inquieto"
    ],
    "orgaoIds": [
      "coracao",
      "vesicula-biliar",
      "figado",
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo coracao, vesicula-biliar, figado, rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "muitos-sonhos",
    "sintoma": "Muitos sonhos",
    "aliases": [
      "sonhos excessivos",
      "sono com muitos sonhos"
    ],
    "orgaoIds": [
      "coracao",
      "vesicula-biliar",
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo coracao, vesicula-biliar, figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "pesadelos",
    "sintoma": "Pesadelos",
    "aliases": [
      "sonhos ruins",
      "sonhos assustadores",
      "acorda assustado"
    ],
    "orgaoIds": [
      "vesicula-biliar",
      "coracao"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo vesicula-biliar, coracao.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "esquecimento",
    "sintoma": "Esquecimento",
    "aliases": [
      "memória fraca",
      "memória ruim",
      "dificuldade de memória",
      "esquecendo coisas"
    ],
    "orgaoIds": [
      "coracao",
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo coracao, rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "agitacao-mental",
    "sintoma": "Agitação mental",
    "aliases": [
      "mente agitada",
      "inquietação",
      "desassossego",
      "não consegue relaxar"
    ],
    "orgaoIds": [
      "coracao",
      "pericardio",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo coracao, pericardio, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "tontura",
    "sintoma": "Tontura",
    "aliases": [
      "vertigem",
      "cabeça girando",
      "cabeça leve"
    ],
    "orgaoIds": [
      "coracao",
      "figado",
      "rins",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo coracao, figado, rins, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "visao-turva",
    "sintoma": "Visão turva",
    "aliases": [
      "vista embaçada",
      "visão borrada",
      "visão fraca"
    ],
    "orgaoIds": [
      "figado",
      "coracao",
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado, coracao, rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "olhos-secos",
    "sintoma": "Olhos secos",
    "aliases": [
      "secura nos olhos"
    ],
    "orgaoIds": [
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "olhos-vermelhos",
    "sintoma": "Olhos vermelhos",
    "aliases": [
      "olhos irritados",
      "olhos doloridos",
      "olho ardendo"
    ],
    "orgaoIds": [
      "figado",
      "vesicula-biliar",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado, vesicula-biliar, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "moscas-volantes",
    "sintoma": "Moscas volantes",
    "aliases": [
      "pontos na visão",
      "floaters"
    ],
    "orgaoIds": [
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-de-cabeca-lateral",
    "sintoma": "Dor de cabeça lateral ou nas têmporas",
    "aliases": [
      "cefaleia temporal",
      "dor na têmpora",
      "cefaleia lateral",
      "dor lateral da cabeça"
    ],
    "orgaoIds": [
      "figado",
      "vesicula-biliar",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado, vesicula-biliar, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "suspiros-frequentes",
    "sintoma": "Suspiros frequentes",
    "aliases": [
      "suspirar muito"
    ],
    "orgaoIds": [
      "figado",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-nas-costelas",
    "sintoma": "Dor nas laterais das costelas",
    "aliases": [
      "dor nas costelas",
      "dor no hipocôndrio",
      "dor debaixo das costelas"
    ],
    "orgaoIds": [
      "figado",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "distensao-nas-costelas",
    "sintoma": "Distensão nas costelas",
    "aliases": [
      "pressão nas costelas",
      "estufamento lateral"
    ],
    "orgaoIds": [
      "figado",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "no-na-garganta",
    "sintoma": "Nó na garganta",
    "aliases": [
      "bolo na garganta",
      "algo preso na garganta"
    ],
    "orgaoIds": [
      "figado",
      "pulmao"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado, pulmao.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "tensao-muscular",
    "sintoma": "Tensão muscular",
    "aliases": [
      "músculos tensos"
    ],
    "orgaoIds": [
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dormencia",
    "sintoma": "Dormência ou formigamento",
    "aliases": [
      "formigamento",
      "membros dormentes",
      "mãos e pés dormentes",
      "parestesia",
      "agulhadas"
    ],
    "orgaoIds": [
      "figado",
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado, rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "tremores",
    "sintoma": "Tremores",
    "aliases": [
      "tremedeira",
      "tremor"
    ],
    "orgaoIds": [
      "figado",
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado, rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "caibras",
    "sintoma": "Cãibras ou contrações",
    "aliases": [
      "espasmos",
      "contrações musculares"
    ],
    "orgaoIds": [
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "gosto-amargo",
    "sintoma": "Gosto amargo na boca",
    "aliases": [
      "boca amarga",
      "amargor"
    ],
    "orgaoIds": [
      "vesicula-biliar",
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo vesicula-biliar, figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "boca-seca",
    "sintoma": "Boca seca",
    "aliases": [
      "secura na boca",
      "garganta seca"
    ],
    "orgaoIds": [
      "estomago",
      "rins",
      "figado",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago, rins, figado, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "sede",
    "sintoma": "Sede",
    "aliases": [
      "muita sede"
    ],
    "orgaoIds": [
      "estomago",
      "bexiga"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago, bexiga.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "falta-de-apetite",
    "sintoma": "Falta de apetite",
    "aliases": [
      "pouco apetite",
      "sem fome",
      "perda de apetite",
      "apetite reduzido",
      "pouca vontade de comer"
    ],
    "orgaoIds": [
      "baco-pancreas",
      "estomago",
      "figado",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas, estomago, figado, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "fome-sem-vontade",
    "sintoma": "Fome sem vontade de comer",
    "aliases": [
      "sente fome mas não quer comer"
    ],
    "orgaoIds": [
      "estomago"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "fome-excessiva",
    "sintoma": "Fome excessiva",
    "aliases": [
      "fome logo após comer",
      "fome rápida"
    ],
    "orgaoIds": [
      "estomago"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "empachamento",
    "sintoma": "Empachamento",
    "aliases": [
      "estômago cheio",
      "plenitude após comer",
      "estufamento após comer"
    ],
    "orgaoIds": [
      "baco-pancreas",
      "estomago"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas, estomago.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "distensao-abdominal",
    "sintoma": "Distensão abdominal",
    "aliases": [
      "barriga inchada",
      "barriga estufada",
      "inchaço abdominal"
    ],
    "orgaoIds": [
      "baco-pancreas",
      "estomago",
      "figado",
      "intestino-grosso",
      "intestino-delgado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas, estomago, figado, intestino-grosso, intestino-delgado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-abdominal",
    "sintoma": "Dor abdominal",
    "aliases": [
      "dor na barriga",
      "cólica abdominal"
    ],
    "orgaoIds": [
      "estomago",
      "intestino-delgado",
      "intestino-grosso",
      "baco-pancreas",
      "figado",
      "bexiga"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago, intestino-delgado, intestino-grosso, baco-pancreas, figado, bexiga.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-no-estomago",
    "sintoma": "Dor no estômago",
    "aliases": [
      "dor gástrica",
      "dor epigástrica"
    ],
    "orgaoIds": [
      "estomago",
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago, figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "queimacao-no-estomago",
    "sintoma": "Queimação no estômago",
    "aliases": [
      "ardência gástrica",
      "estômago queimando"
    ],
    "orgaoIds": [
      "estomago"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "azia-refluxo",
    "sintoma": "Azia ou refluxo",
    "aliases": [
      "queimação",
      "refluxo ácido",
      "regurgitação ácida",
      "ácido voltando"
    ],
    "orgaoIds": [
      "estomago",
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago, figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "arroto",
    "sintoma": "Arroto",
    "aliases": [
      "eructação",
      "arrotos frequentes"
    ],
    "orgaoIds": [
      "estomago",
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago, figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "soluco",
    "sintoma": "Soluço",
    "aliases": [
      "soluços"
    ],
    "orgaoIds": [
      "estomago",
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago, figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "nausea",
    "sintoma": "Náusea",
    "aliases": [
      "enjoo",
      "ânsia"
    ],
    "orgaoIds": [
      "estomago",
      "figado",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago, figado, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "vomito",
    "sintoma": "Vômito",
    "aliases": [
      "vomitando",
      "ânsia com vômito"
    ],
    "orgaoIds": [
      "estomago",
      "figado",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago, figado, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "mau-halito",
    "sintoma": "Mau hálito",
    "aliases": [
      "hálito ruim",
      "bafo"
    ],
    "orgaoIds": [
      "estomago"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "gengiva-inchada",
    "sintoma": "Gengiva inchada ou dolorida",
    "aliases": [
      "gengiva dolorida",
      "gengiva vermelha"
    ],
    "orgaoIds": [
      "estomago"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "sangramento-gengival",
    "sintoma": "Sangramento gengival",
    "aliases": [
      "gengiva sangrando"
    ],
    "orgaoIds": [
      "estomago"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo estomago.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "boca-sem-gosto",
    "sintoma": "Boca sem gosto",
    "aliases": [
      "paladar fraco",
      "comida sem gosto"
    ],
    "orgaoIds": [
      "baco-pancreas"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "cansaco-depois-de-comer",
    "sintoma": "Cansaço depois de comer",
    "aliases": [
      "sono após refeição",
      "fraqueza depois de comer"
    ],
    "orgaoIds": [
      "baco-pancreas"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "sensacao-de-peso",
    "sintoma": "Sensação de peso no corpo",
    "aliases": [
      "corpo pesado",
      "membros pesados"
    ],
    "orgaoIds": [
      "baco-pancreas"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "fezes-moles",
    "sintoma": "Fezes moles",
    "aliases": [
      "fezes pastosas",
      "fezes sem forma"
    ],
    "orgaoIds": [
      "baco-pancreas",
      "intestino-grosso"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas, intestino-grosso.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "diarreia",
    "sintoma": "Diarreia",
    "aliases": [
      "intestino solto",
      "evacuação líquida",
      "diarreia com cólica"
    ],
    "orgaoIds": [
      "baco-pancreas",
      "intestino-grosso",
      "intestino-delgado",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas, intestino-grosso, intestino-delgado, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "diarreia-urgente",
    "sintoma": "Diarreia urgente",
    "aliases": [
      "urgência para evacuar",
      "corre para o banheiro"
    ],
    "orgaoIds": [
      "intestino-grosso"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "diarreia-com-ardor",
    "sintoma": "Diarreia com ardor",
    "aliases": [
      "evacuação ardendo",
      "ânus queimando",
      "ardor anal"
    ],
    "orgaoIds": [
      "intestino-grosso"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "muco-nas-fezes",
    "sintoma": "Muco nas fezes",
    "aliases": [
      "fezes com muco",
      "cocô com muco",
      "fezes gosmentas"
    ],
    "orgaoIds": [
      "intestino-grosso"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "sangue-nas-fezes",
    "sintoma": "Sangue nas fezes",
    "aliases": [
      "fezes com sangue",
      "cocô com sangue",
      "evacuação com sangue"
    ],
    "orgaoIds": [
      "intestino-grosso"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas.",
    "alerta": "Sangue nas fezes merece avaliação médica."
  },
  {
    "id": "evacuacao-incompleta",
    "sintoma": "Sensação de evacuação incompleta",
    "aliases": [
      "ainda precisa evacuar",
      "intestino não esvazia",
      "tenesmo"
    ],
    "orgaoIds": [
      "intestino-grosso"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "fezes-odor-forte",
    "sintoma": "Fezes com odor muito forte",
    "aliases": [
      "fezes muito fedidas",
      "evacuação com cheiro forte"
    ],
    "orgaoIds": [
      "intestino-grosso",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "fezes-pegajosas",
    "sintoma": "Fezes pegajosas",
    "aliases": [
      "fezes grudentas",
      "cocô pegajoso"
    ],
    "orgaoIds": [
      "intestino-grosso"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "constipacao",
    "sintoma": "Constipação",
    "aliases": [
      "prisão de ventre",
      "intestino preso",
      "dificuldade para evacuar"
    ],
    "orgaoIds": [
      "intestino-grosso",
      "estomago",
      "intestino-delgado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso, estomago, intestino-delgado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "fezes-secas",
    "sintoma": "Fezes secas e duras",
    "aliases": [
      "cocô ressecado",
      "fezes muito duras"
    ],
    "orgaoIds": [
      "intestino-grosso",
      "estomago"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso, estomago.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "gases",
    "sintoma": "Gases",
    "aliases": [
      "flatulência",
      "muitos gases"
    ],
    "orgaoIds": [
      "intestino-grosso",
      "baco-pancreas",
      "estomago",
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-grosso, baco-pancreas, estomago, figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "barulhos-intestinais",
    "sintoma": "Barulhos intestinais",
    "aliases": [
      "barriga roncando",
      "borborigmos"
    ],
    "orgaoIds": [
      "baco-pancreas",
      "intestino-delgado",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas, intestino-delgado, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-baixo-ventre",
    "sintoma": "Dor no baixo ventre",
    "aliases": [
      "dor abdominal inferior",
      "dor abaixo do umbigo",
      "dor suprapúbica"
    ],
    "orgaoIds": [
      "intestino-delgado",
      "bexiga",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-delgado, bexiga, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "distensao-baixo-ventre",
    "sintoma": "Distensão no baixo ventre",
    "aliases": [
      "pressão no baixo ventre",
      "barriga baixa estufada"
    ],
    "orgaoIds": [
      "intestino-delgado",
      "bexiga",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-delgado, bexiga, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-abdominal-para-testiculo",
    "sintoma": "Dor abdominal irradiando para testículo",
    "aliases": [
      "dor na barriga descendo para testículo",
      "dor testicular com dor abdominal"
    ],
    "orgaoIds": [
      "intestino-delgado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-delgado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-garganta",
    "sintoma": "Dor de garganta",
    "aliases": [
      "garganta dolorida",
      "garganta inflamada"
    ],
    "orgaoIds": [
      "intestino-delgado",
      "triplo-aquecedor",
      "pulmao"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-delgado, triplo-aquecedor, pulmao.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-pescoco-ombro",
    "sintoma": "Dor no pescoço ou ombro",
    "aliases": [
      "pescoço dolorido",
      "ombro dolorido",
      "pescoço travado",
      "dificuldade de virar o pescoço"
    ],
    "orgaoIds": [
      "intestino-delgado",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-delgado, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-parte-posterior-braco",
    "sintoma": "Dor na parte posterior do braço",
    "aliases": [
      "dor atrás do braço",
      "dor do ombro ao cotovelo"
    ],
    "orgaoIds": [
      "intestino-delgado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-delgado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "bochecha-inchada",
    "sintoma": "Bochecha inchada",
    "aliases": [
      "inchaço na bochecha",
      "rosto inchado de um lado"
    ],
    "orgaoIds": [
      "intestino-delgado",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo intestino-delgado, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-lombar",
    "sintoma": "Dor lombar",
    "aliases": [
      "dor nas costas embaixo",
      "lombalgia",
      "fraqueza lombar",
      "lombar fraca"
    ],
    "orgaoIds": [
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "joelhos-fracos",
    "sintoma": "Joelhos fracos ou doloridos",
    "aliases": [
      "fraqueza nos joelhos",
      "pernas bambas",
      "dor nos joelhos"
    ],
    "orgaoIds": [
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "urinacao-frequente",
    "sintoma": "Urinação frequente",
    "aliases": [
      "urinar muito",
      "muita urina",
      "fazer xixi toda hora"
    ],
    "orgaoIds": [
      "rins",
      "bexiga"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins, bexiga.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "nocturia",
    "sintoma": "Urinar à noite",
    "aliases": [
      "noctúria",
      "levantar para urinar"
    ],
    "orgaoIds": [
      "rins",
      "bexiga"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins, bexiga.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "incontinencia-urinaria",
    "sintoma": "Incontinência urinária",
    "aliases": [
      "perda de urina",
      "escape de urina",
      "urina escapando ao tossir"
    ],
    "orgaoIds": [
      "rins",
      "bexiga",
      "pulmao"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins, bexiga, pulmao.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dificuldade-urinar",
    "sintoma": "Dificuldade para urinar",
    "aliases": [
      "urina presa",
      "pouca urina",
      "não consegue urinar"
    ],
    "orgaoIds": [
      "bexiga",
      "rins",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo bexiga, rins, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "urgencia-urinaria",
    "sintoma": "Urgência urinária",
    "aliases": [
      "vontade urgente de urinar"
    ],
    "orgaoIds": [
      "bexiga"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo bexiga.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "ardor-urinar",
    "sintoma": "Ardor ou dor ao urinar",
    "aliases": [
      "queimação para urinar",
      "urina ardendo",
      "urinação dolorosa"
    ],
    "orgaoIds": [
      "bexiga",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo bexiga, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "urina-turva",
    "sintoma": "Urina turva",
    "aliases": [
      "xixi turvo"
    ],
    "orgaoIds": [
      "bexiga"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo bexiga.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "urina-escura",
    "sintoma": "Urina escura",
    "aliases": [
      "xixi escuro",
      "urina amarelo-escura"
    ],
    "orgaoIds": [
      "bexiga",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo bexiga, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "zumbido",
    "sintoma": "Zumbido",
    "aliases": [
      "ouvido apitando",
      "chiado no ouvido",
      "tinnitus"
    ],
    "orgaoIds": [
      "rins",
      "vesicula-biliar",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins, vesicula-biliar, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "audicao-reduzida",
    "sintoma": "Audição reduzida",
    "aliases": [
      "perda auditiva",
      "ouvir menos"
    ],
    "orgaoIds": [
      "rins",
      "intestino-delgado",
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins, intestino-delgado, triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "libido-baixa",
    "sintoma": "Libido baixa",
    "aliases": [
      "pouco desejo sexual",
      "falta de desejo"
    ],
    "orgaoIds": [
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "disfuncao-eretil",
    "sintoma": "Disfunção erétil",
    "aliases": [
      "impotência",
      "dificuldade de ereção"
    ],
    "orgaoIds": [
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "suor-noturno",
    "sintoma": "Suor noturno",
    "aliases": [
      "suar dormindo"
    ],
    "orgaoIds": [
      "rins",
      "coracao"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins, coracao.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "calor-palmas-plantas",
    "sintoma": "Calor nas palmas e plantas",
    "aliases": [
      "mãos e pés quentes",
      "cinco centros quentes",
      "palma quente"
    ],
    "orgaoIds": [
      "rins",
      "coracao",
      "estomago",
      "pericardio"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins, coracao, estomago, pericardio.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "frio-maos-pes",
    "sintoma": "Frio nas mãos e pés",
    "aliases": [
      "extremidades frias",
      "mãos frias",
      "pés frios"
    ],
    "orgaoIds": [
      "rins",
      "baco-pancreas",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins, baco-pancreas, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "queda-cabelo",
    "sintoma": "Queda de cabelo",
    "aliases": [
      "cabelo caindo",
      "cabelo enfraquecido"
    ],
    "orgaoIds": [
      "rins",
      "figado"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins, figado.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dentes-frouxos",
    "sintoma": "Dentes frouxos",
    "aliases": [
      "dentes amolecidos"
    ],
    "orgaoIds": [
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "edema",
    "sintoma": "Edema ou retenção de líquidos",
    "aliases": [
      "inchaço",
      "retenção de líquido",
      "líquido acumulado",
      "pernas inchadas",
      "corpo inchado"
    ],
    "orgaoIds": [
      "triplo-aquecedor",
      "rins",
      "baco-pancreas"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo triplo-aquecedor, rins, baco-pancreas.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-ouvido",
    "sintoma": "Dor de ouvido",
    "aliases": [
      "ouvido doendo",
      "dor dentro do ouvido",
      "dor atrás da orelha"
    ],
    "orgaoIds": [
      "triplo-aquecedor",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo triplo-aquecedor, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-canto-externo-olho",
    "sintoma": "Dor no canto externo do olho",
    "aliases": [
      "dor na lateral do olho",
      "canto do olho dolorido"
    ],
    "orgaoIds": [
      "triplo-aquecedor",
      "vesicula-biliar"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo triplo-aquecedor, vesicula-biliar.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dor-lateral-braco",
    "sintoma": "Dor lateral no braço",
    "aliases": [
      "dor por fora do braço",
      "dor do ombro ao antebraço"
    ],
    "orgaoIds": [
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "dedo-anelar-dolorido",
    "sintoma": "Dedo anelar dolorido ou rígido",
    "aliases": [
      "dor no dedo anelar",
      "anelar travado"
    ],
    "orgaoIds": [
      "triplo-aquecedor"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo triplo-aquecedor.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "espasmo-antebraco",
    "sintoma": "Espasmo no antebraço ou cotovelo",
    "aliases": [
      "braço contraindo",
      "espasmo no braço"
    ],
    "orgaoIds": [
      "pericardio"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo pericardio.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "inchaco-axila",
    "sintoma": "Inchaço na axila",
    "aliases": [
      "axila inchada"
    ],
    "orgaoIds": [
      "pericardio"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo pericardio.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "aversao-gordurosos",
    "sintoma": "Aversão a alimentos gordurosos",
    "aliases": [
      "gordura dá enjoo",
      "não tolera comida gordurosa",
      "mal-estar com fritura"
    ],
    "orgaoIds": [
      "vesicula-biliar",
      "baco-pancreas",
      "estomago"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo vesicula-biliar, baco-pancreas, estomago.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "fadiga",
    "sintoma": "Fadiga",
    "aliases": [
      "cansaço",
      "cansado",
      "falta de energia",
      "energia baixa",
      "indisposição",
      "fraqueza"
    ],
    "orgaoIds": [
      "baco-pancreas",
      "pulmao",
      "coracao",
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo baco-pancreas, pulmao, coracao, rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  },
  {
    "id": "palidez",
    "sintoma": "Palidez",
    "aliases": [
      "rosto pálido",
      "aparência pálida"
    ],
    "orgaoIds": [
      "coracao",
      "figado",
      "baco-pancreas",
      "rins"
    ],
    "relacoes": "Na MTC, pode aparecer associado a padrões envolvendo coracao, figado, baco-pancreas, rins.",
    "contexto": "Pode aparecer em diferentes padrões da MTC envolvendo os sistemas relacionados; interpretar em conjunto com outros sinais e sintomas."
  }
];

export const SYMPTOM_DISCLAIMER =
  "Este guia é educativo. Sintomas intensos, persistentes ou preocupantes pedem avaliação profissional.";
